
import { i18nText } from '@/locales';
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {minValue, required} from "vuelidate/lib/validators";

export class ProductFormData {
    @Validate(required, i18nText("Обязательное поле"))
    name: string
    check: string
    vendor_code: string
    barcode: string
    @Validate(required, i18nText("Обязательное поле"))
    category_id: number | null
    tax_id: number | null
    tax_system_id: number | null
    @Validate(required, i18nText("Обязательное поле"))
    sale_unit_id: number | null
    @Validate(required, i18nText("Обязательное поле"))
    @Validate(minValue(1), i18nText("Поле должно быть больше 0"))
    sale_unit_value: number
    @Validate(required, i18nText("Обязательное поле"))
    writeoff_unit_id: number | null
    writeoff_unit_value: number
    net_weight: number
    gross_weight: number
    @Validate(required, i18nText("Обязательное поле"))
    @Validate(minValue(1), i18nText("Поле должно быть больше 0"))
    selling_price: number
    cost_price: number
    critical_remainder: number
    wish_remainder: number
    salon_id: number | null
    store_id: number | null
    service_id: number | null
    quantity: number
    comment: string

    constructor(salon_id: number, store_id: number) {
        this.name = ''
        this.check = ''
        this.vendor_code = ''
        this.barcode = ''
        this.category_id = null
        this.tax_id = null
        this.tax_system_id = null
        this.sale_unit_id = null
        this.sale_unit_value = 0
        this.writeoff_unit_id = null
        this.writeoff_unit_value = 0
        this.net_weight = 0
        this.gross_weight = 0
        this.selling_price = 0
        this.cost_price = 0
        this.critical_remainder = 0
        this.wish_remainder = 0
        this.salon_id = salon_id
        this.store_id = store_id
        this.service_id = null
        this.quantity = 0
        this.comment = ''
    }
}

export const FormRules = {
    name: [
        {required: true, message: i18nText("Пожалуйста укажите наименование"), trigger: 'change'},
        {min: 2, message: 'Length should be 3 to 5', trigger: 'blur'},
    ],
    category_id: [
        {required: true, message: i18nText("Пожалуйста укажите категорию"), trigger: 'change'}
    ],
    sale_unit_id: [
        {required: true, message: i18nText("Пожалуйста укажите ед.изм."), trigger: 'change'}
    ],
    writeoff_unit_id: [
        {required: true, message: i18nText("Пожалуйста укажите ед. списания."), trigger: 'change'}
    ],
    sale_unit_value: [
        {required: true, message: i18nText("Поле \"Равно\" не может быть пустым."), trigger: 'change'},
        {min: 1, message: i18nText("Поле должно быть больше 0"), trigger: 'change', type: 'number'}
    ]

}
